export class UsersCountersModel {
  constructor(public nbrOfManager: number,
              public nbrOfStaff: number) {}
}
